import React, { PureComponent, Fragment } from 'react';
import { IUser } from 'types';
import ImageAvatar from 'ui/image/image-avatar';
import storeConnect from 'data/store-connect';
import userStore from 'data/user';

// Components

interface UserPhotoProps {
  uid: string;
  showName?: boolean;
  user?: IUser;
  className: string;
}
const storeMap = {
  user: ({ uid, user }) => user || userStore.getUser(uid) || {}
};
@storeConnect(storeMap, [userStore])
class UserPhoto extends PureComponent<UserPhotoProps> {
  render() {
    const { uid, user, showName, className, ...rest } = this.props;
    let cl = 'row v-center h-start';
    if (className) cl += ' ' + className;
    return (
      <Fragment>
        <ImageAvatar {...rest} small image={user && user.photoURL} />
        {showName && (
          <div className="tiny-margin primary-text">{user.displayName || user.email}</div>
        )}
      </Fragment>
    );
  }
}

export default UserPhoto;
